import PropTypes from 'prop-types'
import React from 'react'

import { Content } from './styles'

import { getNoOfParticipantsText } from '../../helper/participants'

const ParticipantsCount = ({ participants, preClassHost }) => {
    const noOfParticipantsInClassCopy = getNoOfParticipantsText(
        participants,
        preClassHost
    )
    return (
        <Content noOfParticipants={participants.length}>
            {noOfParticipantsInClassCopy}
        </Content>
    )
}

ParticipantsCount.propTypes = { participants: PropTypes.number.isRequired }

export default ParticipantsCount
